/* Ballon King homepage v3: behaviour layer. Vanilla ES2018, no dependencies.
   Ported from V3.dc.html (spring engine, rails, sheets, calendar, cart flight).
   Every feature no-ops when its data-bk-* hooks are missing. */
(function () {
  'use strict';

  // Pure logic (Europe/Zurich cutoff + wish-date calendar). Testable in node.
  var DAY = 864e5, H16 = 16 * 36e5;
  var WD = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  var WDL = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  var MS = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sept.', 'Okt.', 'Nov.', 'Dez.'];
  var ML = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

  function wd(ms) { return new Date(ms).getUTCDay(); }
  function fmt(ms) { var x = new Date(ms); return WD[x.getUTCDay()] + ', ' + x.getUTCDate() + '. ' + MS[x.getUTCMonth()]; }

  // Wall-clock Zurich time encoded as a fake-UTC timestamp (so day maths ignores DST)
  function zurich(ms) {
    try {
      var p = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Zurich', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })
        .formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = +x.value; });
      return { now: Date.UTC(p.year, p.month - 1, p.day, p.hour % 24, p.minute, p.second), today: Date.UTC(p.year, p.month - 1, p.day) };
    } catch (_) {
      var d = new Date(ms);
      return { now: Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds()), today: Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()) };
    }
  }

  // Next order cutoff (Mo-Fr 16:00) and its delivery day
  function cutoffText(ms) {
    var z = zurich(ms), cutAt = 0, cutDay = 0, delDay = 0;
    for (var k = 0; k < 8; k++) {
      var day = z.today + k * DAY, w = wd(day);
      if (w >= 1 && w <= 5 && day + H16 > z.now) { cutDay = day; cutAt = day + H16; delDay = day + (w === 5 ? 3 : 1) * DAY; break; }
    }
    var mins = Math.max(1, Math.ceil((cutAt - z.now) / 6e4)), hh = Math.floor(mins / 60), mm = mins % 60;
    var lead = hh >= 24 ? 'Noch ' + Math.floor(hh / 24) + ' Tg. ' + (hh % 24) + ' Std.' : (hh >= 1 ? 'Noch ' + hh + ' Std. ' + mm + ' Min.' : 'Noch ' + mm + ' Min.');
    var cutTxt = cutDay === z.today ? 'bis 16.00 Uhr bestellt' : (cutDay === z.today + DAY ? 'bis morgen 16.00 Uhr bestellt' : 'bis ' + WDL[wd(cutDay)] + ' 16.00 Uhr bestellt');
    var delTxt = delDay === z.today + DAY ? 'morgen geliefert' : 'am ' + WDL[wd(delDay)] + ' geliefert';
    return { lead: lead, rest: cutTxt + ', ' + delTxt };
  }

  // Buunto date-picker rules. Defaults mirror the shop settings (03.10.2026) and are
  // refreshed at runtime from cdn.buunto.com (applyBuunto), so holidays stay in sync.
  var WDN = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
  var RULES = {
    delivery: { cut: { DEFAULT: ['16:00', 1], MONDAY: ['16:00', 3] }, days: [1, 2, 3, 4, 5, 6],
      off: ['2026-12-25', '2026-12-26', '2026-12-28', '2027-01-01', '2027-01-02', '2027-01-04', '2027-03-26', '2027-03-29', '2027-05-01', '2027-05-17'] },
    pickup: { cut: { DEFAULT: ['16:00', 0], SATURDAY: ['12:00', 0] }, days: [1, 2, 3, 4, 5, 6],
      off: ['2026-12-25', '2026-12-26', '2027-01-01', '2027-01-02', '2027-03-26', '2027-03-29', '2027-05-01', '2027-05-17'] },
    charges: [{ day: 'SATURDAY', method: 'delivery', variant: 42097115300069, price: 7.9 }]
  };
  function isoDay(ms) { return new Date(ms).toISOString().slice(0, 10); }
  function hm(t) { var p = String(t || '16:00').split(':'); return (+p[0] || 0) * 36e5 + (+p[1] || 0) * 6e4; }
  function rulesOf(method) { return RULES[method === 'pickup' ? 'pickup' : 'delivery']; }
  function closedOn(ms, method) { var r = rulesOf(method); return r.days.indexOf(wd(ms)) < 0 || r.off.indexOf(isoDay(ms)) >= 0; }
  // Latest order moment for a wish date (fake-UTC Zurich wall clock); 0 = not bookable at all
  function cutoffFor(ms, method) {
    if (closedOn(ms, method)) return 0;
    var r = rulesOf(method), c = r.cut[WDN[wd(ms)]] || r.cut.DEFAULT;
    return ms - c[1] * DAY + hm(c[0]);
  }
  function hhmm(ms) { var d = new Date(ms); return d.getUTCHours() + '.' + ('0' + d.getUTCMinutes()).slice(-2); }
  function surchargeFor(ms, method) {
    var m = method === 'pickup' ? 'pickup' : 'delivery', iso = isoDay(ms), hit = null;
    RULES.charges.forEach(function (c) { if (c.method === m && c.day === 'SPECIFIC_DATE' && c.date === iso) hit = c; });
    if (!hit) RULES.charges.forEach(function (c) { if (!hit && c.method === m && c.day === WDN[wd(ms)]) hit = c; });
    return hit;
  }
  function applyBuunto(s) {
    if (!s) return;
    var conv = function (o) {
      var out = null;
      Object.keys(o || {}).forEach(function (k) { out = out || {}; out[k] = [o[k].cutOffTime || '16:00', +o[k].firstAvailableDateInDays || 0]; });
      return out && out.DEFAULT ? out : null;
    };
    var days = function (a) { return Array.isArray(a) ? a.map(function (n) { return WDN.indexOf(n); }).filter(function (i) { return i >= 0; }) : null; };
    var d = conv(s.cutOffByDay), p = conv(s.pickupCutOffByDay), ad = s.availableDaysByMethod || {};
    if (d) RULES.delivery.cut = d;
    if (p) RULES.pickup.cut = p;
    if (Array.isArray(s.disabledDates)) RULES.delivery.off = s.disabledDates.slice();
    if (Array.isArray(s.pickupDisabledDates)) RULES.pickup.off = s.pickupDisabledDates.slice();
    RULES.delivery.days = days(ad.LOCAL_DELIVERY) || RULES.delivery.days;
    RULES.pickup.days = days(ad.STORE_PICKUP) || RULES.pickup.days;
    if (Array.isArray(s.shippingCharges)) {
      RULES.charges = s.shippingCharges.filter(function (c) { return c.product && c.product.variantId; }).map(function (c) {
        return { day: c.day, date: c.date, method: c.method === 'STORE_PICKUP' ? 'pickup' : 'delivery', variant: +c.product.variantId, price: +c.product.price };
      });
    }
  }

  // Month grid + result card for the calendar. calMonth = offset from the current month (0..2)
  function calModel(ms, calMonth, selMs, method, lockMs) {
    var z = zurich(ms);
    var y0 = new Date(z.today).getUTCFullYear(), m0 = new Date(z.today).getUTCMonth();
    var first = Date.UTC(y0, m0 + calMonth, 1), fd = new Date(first);
    var Y = fd.getUTCFullYear(), M = fd.getUTCMonth();
    var nDays = new Date(Date.UTC(Y, M + 1, 0)).getUTCDate(), lead = (fd.getUTCDay() + 6) % 7;
    var sel = selMs && cutoffFor(selMs, method) > z.now ? selMs : 0;
    var days = [], i;
    for (i = 0; i < lead; i++) days.push({ empty: true });
    for (i = 1; i <= nDays; i++) {
      var d = Date.UTC(Y, M, i), ok = cutoffFor(d, method) > z.now && (!lockMs || d === lockMs), w = wd(d);
      var why = w === 0 ? ', keine Zustellung' : (closedOn(d, method) ? ', Feiertag' : ', nicht mehr möglich');
      days.push({
        ms: d, label: String(i), ok: ok, sat: !!surchargeFor(d, method), today: d === z.today, on: d === sel,
        aria: fmt(d) + (ok ? '' : why)
      });
    }
    while (days.length % 7) days.push({ empty: true });
    return {
      month: ML[M] + ' ' + Y, days: days, sel: sel,
      res: sel ? {
        line: 'Bestell bis ' + fmt(cutoffFor(sel, method)) + ', ' + hhmm(cutoffFor(sel, method)) + ' Uhr. ' +
          (method === 'pickup' ? 'Abholbereit am ' + fmt(sel) + ' in unserem Laden in Zollikon, Helium schon drin.' : 'Dein Ballon kommt am ' + fmt(sel) + ' an, Helium schon drin.'),
        sat: surchargeFor(sel, method)
      } : null
    };
  }

  function rubber(o, dim) { var c = 0.55; return (o * dim * c) / (dim + c * Math.abs(o)); }
  function project(v) { return (v / 1000) * 0.998 / (1 - 0.998); }

  if (typeof module === 'object' && module.exports) {
    module.exports = { zurich: zurich, cutoffText: cutoffText, cutoffFor: cutoffFor, calModel: calModel, fmt: fmt, project: project, rubber: rubber, RULES: RULES, applyBuunto: applyBuunto, surchargeFor: surchargeFor, isoDay: isoDay };
    return;
  }
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.__bkV3) return;
  window.__bkV3 = true;

  // Helpers
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); };
  var mq = function (q) { return !!(window.matchMedia && window.matchMedia(q).matches); };
  var reduced = function () { return mq('(prefers-reduced-motion: reduce)'); };
  var isMobile = function () { return mq('(max-width: 734px)'); };
  var closest = function (e, sel) { return e.target && e.target.closest ? e.target.closest(sel) : null; };

  // Spring engine (damping ratio + response)
  var springs = new Set(), raf = 0;
  function spring(key, o) {
    var s = key.__sp;
    if (!s) { s = { x: o.from, v: 0, key: key }; key.__sp = s; }
    s.to = o.to;
    if (o.v !== undefined) s.v = o.v;
    s.response = o.response || 0.4;
    s.damping = o.damping == null ? 1 : o.damping;
    s.eps = o.eps || 0.5;
    s.apply = o.apply;
    s.done = o.done;
    springs.add(s);
    kick();
    return s;
  }
  function stopSpring(key) {
    if (key && key.__sp) { springs.delete(key.__sp); key.__sp = null; }
  }
  function kick() {
    if (raf) return;
    var last = performance.now();
    var step = function (ts) {
      var dt = Math.min(Math.max((ts - last) / 1000, 0), 1 / 30);
      last = ts;
      springs.forEach(function (s) {
        var n = Math.max(1, Math.ceil(dt * 240)), h = dt / n, w = 2 * Math.PI / s.response;
        for (var i = 0; i < n; i++) {
          var a = -w * w * (s.x - s.to) - 2 * s.damping * w * s.v;
          s.v += a * h; s.x += s.v * h;
        }
        if (Math.abs(s.x - s.to) < s.eps && Math.abs(s.v) < s.eps * 8) {
          s.x = s.to; s.v = 0; s.apply(s.x);
          springs.delete(s); s.key.__sp = null;
          if (s.done) s.done();
        } else s.apply(s.x);
      });
      raf = springs.size ? requestAnimationFrame(step) : 0;
    };
    raf = requestAnimationFrame(step);
  }

  // Rails: 1:1 mouse drag, rubber band, momentum projection, snap, glide
  var RAIL = '[data-bk-rail],[data-bk-hero]';
  var drag = null, suppress = false;

  function snaps(r) {
    var padL = parseFloat(getComputedStyle(r).scrollPaddingLeft) || 0;
    var max = r.scrollWidth - r.clientWidth;
    var ps = $$('[data-bk-snap]', r).map(function (c) { return Math.min(max, Math.max(0, c.offsetLeft - padL)); });
    ps.push(max);
    return ps;
  }
  function nearest(r, x) {
    var ps = snaps(r), best = ps[0] || 0;
    ps.forEach(function (p) { if (Math.abs(p - x) < Math.abs(best - x)) best = p; });
    return best;
  }
  function glide(r, to, v) {
    if (reduced()) { stopSpring(r); r.scrollLeft = to; return; }
    r.style.scrollSnapType = 'none';
    var o = { from: r.scrollLeft, to: to, response: 0.5, damping: 1, eps: 0.5,
      apply: function (x) { r.scrollLeft = x; },
      done: function () { r.style.scrollSnapType = ''; } };
    if (v !== undefined) o.v = v;
    spring(r, o);
  }
  function railDown(e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var r = closest(e, RAIL);
    if (!r) return;
    stopSpring(r);
    if (r.__rbk) { stopSpring(r.__rbk); r.style.transform = ''; }
    drag = { r: r, x0: e.clientX, s0: r.scrollLeft, hist: [{ x: e.clientX, t: e.timeStamp }], moved: false, id: e.pointerId, over: 0 };
  }
  function railMove(e) {
    var d = drag;
    if (!d) return;
    var dx = e.clientX - d.x0;
    if (!d.moved) {
      if (Math.abs(dx) < 6) return;
      d.moved = true; d.x0 = e.clientX; dx = 0;
      try { d.r.setPointerCapture(d.id); } catch (_) {}
      d.r.style.scrollSnapType = 'none';
      d.r.classList.add('grabbing');
    }
    var r = d.r, want = d.s0 - dx, max = r.scrollWidth - r.clientWidth, over = 0;
    if (want < 0) { r.scrollLeft = 0; over = rubber(-want, r.clientWidth); }
    else if (want > max) { r.scrollLeft = max; over = -rubber(want - max, r.clientWidth); }
    else r.scrollLeft = want;
    d.over = over;
    r.style.transform = over ? 'translateX(' + over + 'px)' : '';
    d.hist.push({ x: e.clientX, t: e.timeStamp });
    while (d.hist.length > 2 && e.timeStamp - d.hist[0].t > 100) d.hist.shift();
  }
  function railUp(e) {
    var d = drag;
    if (!d) return;
    drag = null;
    if (!d.moved) return;
    var r = d.r;
    r.classList.remove('grabbing');
    try { r.releasePointerCapture(d.id); } catch (_) {}
    var h = d.hist, a = h[0], b = h[h.length - 1], dt = (b.t - a.t) / 1000;
    var vx = dt > 0.005 ? (b.x - a.x) / dt : 0;
    if (e.timeStamp - b.t > 80) vx = 0;
    if (d.over) {
      r.__rbk = r.__rbk || {};
      spring(r.__rbk, { from: d.over, to: 0, v: vx, response: 0.45, damping: 1, eps: 0.3,
        apply: function (x) { r.style.transform = 'translateX(' + x + 'px)'; },
        done: function () { r.style.transform = ''; r.style.scrollSnapType = ''; } });
    } else {
      glide(r, nearest(r, r.scrollLeft + project(-vx)), -vx);
    }
    suppress = true;
    setTimeout(function () { suppress = false; }, 60);
  }
  function railBy(btn, dir) {
    var s = btn.closest('[data-bk-section]') || btn.closest('.bk') || document;
    // Switcher holds one rail per panel: use the visible one
    var r = [].filter.call(s.querySelectorAll('[data-bk-rail]'), function (x) { return x.offsetParent !== null; })[0];
    if (r) glide(r, nearest(r, r.scrollLeft + dir * r.clientWidth * 0.8));
  }

  // Hero dots / arrows
  function heroOf(el) {
    var s = el.closest('[data-bk-section]') || el.closest('.bk') || document;
    return $('[data-bk-hero]', s);
  }
  function heroSync(h) {
    var s = h.closest('[data-bk-section]') || h.closest('.bk') || document;
    var ps = snaps(h).slice(0, -1), j = 0;
    ps.forEach(function (p, k) { if (Math.abs(p - h.scrollLeft) < Math.abs(ps[j] - h.scrollLeft)) j = k; });
    if (h.scrollLeft >= h.scrollWidth - h.clientWidth - 2) j = ps.length - 1;
    $$('[data-bk-dot]', s).forEach(function (b) {
      var on = +b.getAttribute('data-bk-dot') === j;
      b.classList.toggle('is-on', on);
      if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
    });
  }
  function heroGo(btn, delta, abs) {
    var h = heroOf(btn);
    if (!h) return;
    var n = $$('[data-bk-snap]', h).length || 1;
    var ps = snaps(h).slice(0, -1), cur = 0;
    ps.forEach(function (p, k) { if (Math.abs(p - h.scrollLeft) < Math.abs(ps[cur] - h.scrollLeft)) cur = k; });
    var i = Math.max(0, Math.min(n - 1, abs != null ? abs : cur + delta));
    glide(h, ps[i] != null ? ps[i] : nearest(h, i * h.clientWidth));
  }

  // Pendulum on product cards (mouse only)
  function cardEnter(e) {
    if (e.pointerType !== 'mouse' || reduced()) return;
    var c = closest(e, '.bk-card');
    if (!c || (e.relatedTarget && c.contains(e.relatedTarget))) return;
    var bob = $('.bk-bob', c);
    if (!bob) return;
    var rc = c.getBoundingClientRect();
    var dir = e.clientX < rc.left + rc.width / 2 ? 1 : -1;
    var s = spring(bob, { from: 0, to: 0, response: 0.9, damping: 0.28, eps: 0.05,
      apply: function (x) { bob.style.transform = Math.abs(x) < 0.05 ? '' : 'rotate(' + x + 'deg)'; } });
    s.v += dir * 55;
  }

  // Segmented control (switcher)
  function segScope(seg) { return seg.closest('[data-bk-section]') || seg.closest('.bk') || document; }
  function activeTab(seg) {
    var t = $('[data-bk-tab][aria-selected="true"]', seg) || $('[data-bk-tab].is-on', seg) || $('[data-bk-tab]', seg);
    return t;
  }
  function positionSeg(seg) {
    var b = activeTab(seg), ind = $('[data-bk-seg-ind]', seg);
    if (!b || !ind) return;
    var first = !seg.classList.contains('ready');
    if (first) ind.style.transition = 'none';
    ind.style.width = b.offsetWidth + 'px';
    ind.style.transform = 'translateX(' + b.offsetLeft + 'px)';
    if (first) { void ind.offsetWidth; ind.style.transition = ''; seg.classList.add('ready'); }
    // keep the active segment in view when the control scrolls (phones)
    if (seg.scrollWidth > seg.clientWidth + 1 && seg.__segTab !== b) {
      seg.scrollTo({ left: Math.max(0, b.offsetLeft - 24), behavior: first || reduced() ? 'auto' : 'smooth' });
    }
    seg.__segTab = b;
  }
  function pickTab(btn) {
    var seg = btn.closest('[data-bk-tabs]');
    if (!seg) return;
    var tabs = $$('[data-bk-tab]', seg), i = tabs.indexOf(btn), prev = tabs.indexOf(activeTab(seg));
    if (i < 0 || i === prev) return;
    var scope = segScope(seg);
    tabs.forEach(function (t, j) {
      var on = j === i;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    var panel = null;
    $$('[data-bk-panel]', scope).forEach(function (p) {
      var on = +p.getAttribute('data-bk-panel') === i;
      p.hidden = !on;
      if (on) panel = p;
    });
    var link = $('[data-bk-tab-link]', scope), href = seg.getAttribute('data-href-' + i);
    if (link && href) link.setAttribute('href', href);
    positionSeg(seg);
    if (!panel) return;
    var r = $('[data-bk-rail]', panel) || panel;
    stopSpring(r); r.style.scrollSnapType = ''; r.scrollLeft = 0;
    if (!r.animate) return;
    if (reduced()) r.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200 });
    else r.animate([{ opacity: 0, transform: 'translateX(' + (i > prev ? 48 : -48) + 'px)' }, { opacity: 1, transform: 'none' }], { duration: 480, easing: 'cubic-bezier(.22,.9,.25,1)' });
  }

  // Tab bar: hides on scroll down (distance measured from the turning point)
  var lastY = window.scrollY || 0, turn = lastY, dir = 0;
  function onScroll() {
    var y = window.scrollY || 0, bar = $('[data-bk-tabbar]');
    var d = y > lastY ? 1 : (y < lastY ? -1 : dir);
    if (d !== dir) { dir = d; turn = y; }
    if (bar) {
      if (d > 0 && y - turn > 8 && y > 240) bar.classList.add('min');
      else if ((d < 0 && turn - y > 8) || y < 120) bar.classList.remove('min');
    }
    lastY = y;
  }

  // Sheets (menu / search / cal) + wish-date popover
  var openKind = '', opener = null, sd = null;
  var sheetsEl = function () { return $('[data-bk-sheets]'); };
  var sheetEl = function (k) { return $('[data-bk-sheet="' + k + '"]', sheetsEl() || document); };
  var scrimEl = function () { return $('[data-bk-scrim]'); };

  function setScrim(v) { var sc = scrimEl(); if (sc) sc.style.opacity = v; }

  function menuShow(id, dirn) {
    var sh = sheetEl('menu');
    if (!sh) return;
    var shown = null;
    $$('[data-bk-menu-panel]', sh).forEach(function (p) {
      var on = p.getAttribute('data-bk-menu-panel') === String(id);
      p.hidden = !on;
      if (on) shown = p;
    });
    var title = $('[data-bk-sheet-title]', sh);
    if (title) {
      if (!title.__root) title.__root = title.textContent;
      title.textContent = id === 'root' ? title.__root : (shown && shown.getAttribute('data-title')) || title.__root;
    }
    var back = $('[data-bk-menu-back]', sh);
    if (back) back.hidden = id === 'root';
    if (!shown) return;
    var body = $('[data-bk-sheet-body]', sh) || shown;
    body.scrollTop = 0;
    if (!body.animate || id === 'root' && dirn === 0) return;
    if (reduced()) body.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 180 });
    else body.animate([{ opacity: 0, transform: 'translateX(' + (dirn > 0 ? '40%' : '-30%') + ')' }, { opacity: 1, transform: 'none' }], { duration: 420, easing: 'cubic-bezier(.32,.72,0,1)' });
  }

  function openSheet(kind) {
    var sh = sheetEl(kind);
    if (!sh) return;
    if (openKind) hideSheet(openKind);
    closePop();
    opener = document.activeElement;
    openKind = kind;
    if (kind === 'menu') menuShow('root', 0);
    if (kind === 'cal') renderCals();
    var wrap = sheetsEl();
    if (wrap) { wrap.hidden = false; wrap.classList.add('is-open'); wrap.classList.toggle('is-qa', kind === 'qa'); }
    sh.hidden = false;
    sh.style.transform = ''; sh.__y = 0;
    setScrim('');
    void sh.offsetWidth;
    sh.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    if (!sh.hasAttribute('tabindex')) sh.setAttribute('tabindex', '-1');
    sh.focus({ preventScroll: true });
    if (kind === 'search') { var f = $('[data-bk-search-input]', sh); if (f) f.focus(); }
    $$('[data-bk-open="' + kind + '"],[data-bk-cal-open]').forEach(function (b) {
      if ((b.getAttribute('data-bk-open') || 'cal') === kind) b.setAttribute('aria-expanded', 'true');
    });
  }
  function hideSheet(kind) {
    var sh = sheetEl(kind);
    if (!sh) return;
    stopSpring(sh);
    sh.classList.remove('is-open');
    sh.hidden = true;
    sh.style.transform = ''; sh.__y = 0;
    setScrim('');
    $$('[data-bk-open],[data-bk-cal-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  function sheetClosed(restore) {
    var kind = openKind;
    if (!kind) return;
    openKind = '';
    hideSheet(kind);
    var wrap = sheetsEl();
    if (wrap) { wrap.classList.remove('is-open', 'is-qa'); wrap.hidden = true; }
    document.documentElement.style.overflow = '';
    if (restore && opener && opener.focus) opener.focus({ preventScroll: true });
    opener = null;
  }
  function dismissSheet(el, v) {
    var h = el.offsetHeight || 1;
    spring(el, { from: el.__y || 0, to: h + 40, v: v || 0, response: 0.32, damping: 1, eps: 1,
      apply: function (y) { el.__y = y; el.style.transform = 'translateY(' + y + 'px)'; setScrim(String(Math.max(0, 1 - y / h))); },
      done: function () { sheetClosed(true); } });
  }
  function closeSheet() {
    var el = openKind && sheetEl(openKind);
    if (!el) return;
    if (reduced()) sheetClosed(true); else dismissSheet(el, 0);
  }
  function sheetDown(e) {
    var el = openKind && sheetEl(openKind);
    if (!el) return;
    stopSpring(el);
    sd = { el: el, t: closest(e, '[data-bk-sheet-grab]'), id: e.pointerId, y0: e.clientY, base: el.__y || 0, h: el.offsetHeight || 1, moved: false, hist: [{ y: e.clientY, t: e.timeStamp }] };
  }
  function sheetMove(e) {
    var d = sd;
    if (!d) return;
    var dy = e.clientY - d.y0;
    if (!d.moved) {
      if (Math.abs(dy) < 6) return;
      d.moved = true; d.y0 = e.clientY; dy = 0;
      try { d.t.setPointerCapture(d.id); } catch (_) {}
    }
    var y = d.base + dy;
    if (y < 0) y = -rubber(-y, d.h) * 0.5;
    d.el.__y = y;
    d.el.style.transform = 'translateY(' + y + 'px)';
    setScrim(String(Math.max(0, Math.min(1, 1 - y / d.h))));
    d.hist.push({ y: e.clientY, t: e.timeStamp });
    while (d.hist.length > 2 && e.timeStamp - d.hist[0].t > 100) d.hist.shift();
  }
  function sheetUp(e) {
    var d = sd;
    sd = null;
    if (!d) return;
    var el = d.el;
    var back = function (y, v) {
      spring(el, { from: y, to: 0, v: v, response: 0.3, damping: 0.8, eps: 0.5,
        apply: function (x) { el.__y = x; el.style.transform = Math.abs(x) < 0.5 ? '' : 'translateY(' + x + 'px)'; setScrim(String(Math.max(0, Math.min(1, 1 - x / d.h)))); } });
    };
    if (!d.moved) { // tap that interrupted a dismiss: settle back open
      var y0 = el.__y || 0;
      if (y0 > 0.5) back(y0, 0);
      return;
    }
    try { d.t.releasePointerCapture(d.id); } catch (_) {}
    var h = d.hist, a = h[0], b = h[h.length - 1], dt = (b.t - a.t) / 1000;
    var v = dt > 0.005 ? (b.y - a.y) / dt : 0;
    if (e.timeStamp - b.t > 80) v = 0;
    var y = el.__y || 0;
    if (y + project(v) > d.h * 0.45) {
      if (reduced()) sheetClosed(true); else dismissSheet(el, v);
      return;
    }
    if (reduced()) { el.__y = 0; el.style.transform = ''; setScrim(''); } else back(y, v);
  }

  // Delivery promise + wish-date calendar
  var cal = { month: 0, sel: 0, method: 'delivery' };
  var qa = { month: 0, sel: 0, method: 'delivery', btn: null, lock: null };
  // Wish date survives page loads (per-viewer convenience; bk-pdp.js preselects it in Buunto)
  var WKEY = 'bk:wunsch';
  function saveWish(ms, method) {
    try { localStorage.setItem(WKEY, JSON.stringify({ d: isoDay(ms), m: method === 'pickup' ? 'pickup' : 'delivery' })); } catch (_) {}
  }
  function loadWish() {
    try {
      var o = JSON.parse(localStorage.getItem(WKEY) || 'null');
      if (!o || !/^\d{4}-\d\d-\d\d$/.test(o.d)) return null;
      var ms = Date.parse(o.d + 'T00:00:00Z'), m = o.m === 'pickup' ? 'pickup' : 'delivery';
      return cutoffFor(ms, m) > zurich(Date.now()).now ? { ms: ms, m: m } : null;
    } catch (_) { return null; }
  }
  function monthOff(ms) {
    if (!ms) return 0;
    var t = new Date(zurich(Date.now()).today), d = new Date(ms);
    return Math.max(0, Math.min(2, (d.getUTCFullYear() - t.getUTCFullYear()) * 12 + d.getUTCMonth() - t.getUTCMonth()));
  }
  // Earliest bookable day (Buunto preselects it on the product page too)
  function firstBookable(method) {
    var z = zurich(Date.now());
    for (var k = 0; k < 120; k++) { var d = z.today + k * DAY; if (cutoffFor(d, method) > z.now) return d; }
    return 0;
  }
  function stateOf(el) { return el && el.closest && el.closest('[data-bk-sheet="qa"]') ? qa : cal; }
  var CHEV_L = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 6-6 6 6 6"></path></svg>';
  var CHEV_R = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 6 6 6-6 6"></path></svg>';
  var X_ICO = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"></path></svg>';

  function calHTML(withClose, st) {
    st = st || cal;
    var isQa = st === qa, pick = st.method === 'pickup';
    var m = calModel(Date.now(), st.month, st.sel, st.method, isQa && st.lock ? st.sel : 0);
    st.sel = m.sel;
    var h = '<div class="cal-head"><b>' + m.month + '</b><div class="cal-nav">' +
      '<button type="button" aria-label="Vorheriger Monat" data-bk-cal-prev' + (st.month <= 0 ? ' disabled' : '') + '>' + CHEV_L + '</button>' +
      '<button type="button" aria-label="Nächster Monat" data-bk-cal-next' + (st.month >= 2 ? ' disabled' : '') + '>' + CHEV_R + '</button>' +
      (withClose ? '<button type="button" aria-label="Kalender schliessen" data-bk-cal-close>' + X_ICO + '</button>' : '') +
      '</div></div><div class="cal-grid">' +
      WD.slice(1).concat(WD[0]).map(function (w) { return '<span class="cal-wd">' + w + '</span>'; }).join('');
    m.days.forEach(function (c) {
      if (c.empty) { h += '<button type="button" class="cd empty" disabled tabindex="-1" aria-hidden="true"></button>'; return; }
      h += '<button type="button" class="cd' + (c.sat ? ' sat' : '') + (c.today ? ' today' : '') + (c.on ? ' on' : '') + '"' +
        (c.ok ? '' : ' disabled') + ' aria-label="' + c.aria + '" data-bk-cal-pick="' + c.ms + '">' + c.label + '</button>';
    });
    h += '</div><div class="cal-leg">' + (pick ? '' : '<span><i></i>Samstag mit Zuschlag</span>') + '<span>' + (pick ? 'Sonntag geschlossen' : 'Sonntag keine Zustellung') + '</span></div>';
    if (m.res) {
      var fee = m.res.sat ? '<p>Samstag geht mit Samstagszuschlag' + (m.res.sat.price ? ' (CHF ' + m.res.sat.price.toFixed(2) + ')' : '') + '.</p>' : '';
      h += '<div class="cal-res"><b class="disp" style="font-size:24px;color:#1f9d55">Klappt!</b><p>' + m.res.line + '</p>' + fee +
        (isQa ? '' : '<small>Wir merken uns dein Datum, am Produkt ist es schon eingetragen. An Feiertagen keine Zustellung (je nach Kanton).</small>' +
        '<a class="btn" href="/collections/geschenkballone-alle" style="margin-top:4px">Anlass wählen' + CHEV_R + '</a>') + '</div>';
    }
    return h;
  }
  function renderCals(focusMs) {
    $$('[data-bk-cal]').forEach(function (mount) {
      mount.innerHTML = calHTML(!!mount.closest('[data-bk-cal-pop]'), stateOf(mount));
    });
    if (focusMs) {
      var b = $('[data-bk-cal-pick="' + focusMs + '"]', document);
      var vis = $$('[data-bk-cal-pick="' + focusMs + '"]').filter(function (x) { return x.offsetParent; })[0];
      (vis || b || { focus: function () {} }).focus({ preventScroll: true });
    }
    // trigger labels
    $$('[data-bk-cal-open]').forEach(function (t) {
      var lab = $('[data-bk-cal-label]', t);
      if (!lab) return;
      var inBar = !!t.closest('[data-bk-tabbar]');
      lab.textContent = cal.sel ? (inBar ? fmt(cal.sel) : 'Party am ' + fmt(cal.sel)) : (inBar ? 'Wunschdatum' : 'Wann ist die Party?');
    });
  }
  function calPick(ms) {
    cal.sel = ms;
    saveWish(ms, 'delivery');
    renderCals(ms);
    if (isMobile()) {
      var r = $('[data-bk-sheet="cal"] .cal-res');
      if (r && r.scrollIntoView) r.scrollIntoView({ block: 'nearest', behavior: reduced() ? 'auto' : 'smooth' });
    }
  }
  function popEl() { return $('[data-bk-cal-pop]'); }
  function popOpen() { var p = popEl(); return !!(p && !p.hidden); }
  function setPop(on) {
    var p = popEl();
    if (!p) return;
    if (on) renderCals();
    p.hidden = !on;
    p.classList.toggle('is-open', on);
    $$('[data-bk-cal-open]').forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
  }
  function closePop() { if (popOpen()) setPop(false); }

  function tickCutoff() {
    var t = cutoffText(Date.now());
    $$('[data-bk-cutoff]').forEach(function (c) {
      var l = $('[data-bk-cutoff-lead]', c), r = $('[data-bk-cutoff-rest]', c);
      if (l) l.textContent = t.lead;
      if (r) r.textContent = t.rest;
    });
  }

  // Add to cart: POST /cart/add.js, balloon flight, refresh Symmetry cart
  var flyIdx = 0, toastTimer = 0;

  function toast(msg) {
    var t = $('[data-bk-toast]');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-on'); t.hidden = true; }, 4500);
  }
  // Symmetry header: <a class="cart-link"><span class="cart-link__icon">svg + .cart-link__count</span></a>
  function cartIcon() {
    var c = $$('.cart-link__icon').filter(function (el) { var r = el.getBoundingClientRect(); return r.width > 0 && r.height > 0; });
    return c[0] || $('.cart-link__icon') || $('.cart-link');
  }
  function bumpCart() {
    var ic = cartIcon(), bd = $('.cart-link__count');
    if (reduced()) { if (bd && bd.animate) bd.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200 }); return; }
    if (ic) spring(ic, { from: 1, to: 1, v: 6, response: 0.38, damping: 0.38, eps: 0.002,
      apply: function (x) { ic.style.transform = 'scale(' + x + ')'; } });
    if (bd && bd.animate) bd.animate([{ transform: 'scale(.4)' }, { transform: 'scale(1.15)' }, { transform: 'scale(1)' }], { duration: 420, easing: 'cubic-bezier(.22,.9,.25,1)' });
  }
  // theme.js: document 'theme:cartchanged' -> header re-fetched via ?sections=header, <cart-form> refreshes drawer;
  // detail.openDrawer opens it (theme.settings.after_add_to_cart === 'drawer')
  function refreshCart() {
    var th = window.theme, hasTheme = !!(th && window.jQuery);
    var openDrawer = !!(th && th.settings && th.settings.after_add_to_cart === 'drawer');
    document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false, detail: { openDrawer: openDrawer } }));
    if (hasTheme) { setTimeout(bumpCart, 350); return; }
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      $$('.cart-link__count').forEach(function (n) { n.textContent = c.item_count; });
      if (!$('.cart-link__count')) {
        var holder = $('.cart-link__icon');
        if (holder && c.item_count > 0) { var s = document.createElement('span'); s.className = 'cart-link__count'; s.textContent = c.item_count; holder.appendChild(s); }
      }
      bumpCart();
    }).catch(function () {});
  }
  function fly(btn, done) {
    var cart = cartIcon(), pool = $$('[data-bk-flyer]');
    if (reduced() || !cart || !pool.length) { done(); return; }
    var el = pool[flyIdx++ % pool.length];
    var a = btn.getBoundingClientRect(), b = cart.getBoundingClientRect();
    var x0 = a.left + a.width / 2 - 17, y0 = a.top - 34;
    var x2 = b.left + b.width / 2 - 17, y2 = b.top + b.height / 2 - 30;
    var x1 = x0 + (x2 - x0) * 0.08, y1 = y2 + (y0 - y2) * 0.12;
    var dur = Math.min(1300, Math.max(820, 600 + Math.hypot(x2 - x0, y2 - y0) * 0.4));
    var t0 = performance.now();
    var step = function (now) {
      var t = Math.min(1, (now - t0) / dur);
      var k = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2, u = 1 - k;
      var x = u * u * x0 + 2 * u * k * x1 + k * k * x2;
      var y = u * u * y0 + 2 * u * k * y1 + k * k * y2;
      el.style.opacity = t < 0.08 ? t / 0.08 : (t > 0.88 ? (1 - t) / 0.12 : 1);
      el.style.transform = 'translate(' + x + 'px,' + y + 'px) rotate(' + (Math.sin(t * Math.PI * 3) * 9 * (1 - t)) + 'deg) scale(' + (1 - 0.5 * k * k) + ')';
      if (t < 1) requestAnimationFrame(step);
      else { el.style.opacity = 0; done(); }
    };
    requestAnimationFrame(step);
  }
  function cartJSON() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function postAdd(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok && !j.status, j: j }; });
    });
  }
  function addToCart(btn, props, after) {
    var id = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!id || btn.__busy || btn.disabled) return;
    if (!props && btn.hasAttribute('data-bk-dated')) { datedAdd(btn); return; }
    btn.__busy = true;
    btn.setAttribute('aria-busy', 'true');
    var fail = function (msg) {
      btn.__busy = false; btn.removeAttribute('aria-busy');
      toast(msg || 'Das hat leider nicht geklappt. Bitte versuch es nochmal.');
    };
    var item = { id: id, quantity: 1 };
    if (props) item.properties = props;
    postAdd([item]).then(function (res) {
      if (!res.ok) { fail(res.j.description || res.j.message); return; }
      btn.__busy = false; btn.removeAttribute('aria-busy');
      fly(btn, function () { refreshCart(); if (after) after(); });
    }).catch(function () { fail(); });
  }

  // Heliumballons need Buunto's wish date (same line-item properties as the product page).
  // Buunto allows one date per order: an existing date in the cart wins, otherwise ask.
  function buuntoProps(ms, method) {
    var d = new Date(ms), date = d.getUTCDate() + '. ' + ML[d.getUTCMonth()] + ' ' + d.getUTCFullYear(), day = WDL[d.getUTCDay()];
    return method === 'pickup' ? { Methode: 'Abholung im Geschäft', Abholdatum: date, Abholtag: day } : { Methode: 'Lieferung vor Ort', Lieferdatum: date, Liefertag: day };
  }
  function cartDate(c) {
    var hit = null;
    (c.items || []).forEach(function (it) {
      var p = it.properties || {};
      if (!hit && (p.Lieferdatum || p.Abholdatum)) {
        hit = p.Abholdatum ? { Methode: p.Methode || 'Abholung im Geschäft', Abholdatum: p.Abholdatum, Abholtag: p.Abholtag } : { Methode: p.Methode || 'Lieferung vor Ort', Lieferdatum: p.Lieferdatum, Liefertag: p.Liefertag };
      }
    });
    return hit;
  }
  // Sheet opens at once; an existing cart date (one per order) is applied when /cart.js answers
  function datedAdd(btn) {
    if (btn.__busy) return;
    try { qaOpen(btn, null); } catch (err) { addToCart(btn, buuntoProps(firstBookable('delivery'), 'delivery')); return; }
    cartJSON().then(function (c) {
      var ex = cartDate(c);
      if (ex && openKind === 'qa' && qa.btn === btn) qaLock(ex);
    }).catch(function () {});
  }
  function qaLock(lock) {
    var ms = parseLL(lock.Lieferdatum || lock.Abholdatum);
    qa.lock = lock;
    qa.method = lock.Abholdatum ? 'pickup' : 'delivery';
    qa.sel = ms;
    qa.month = monthOff(ms);
    renderCals();
    qaUI();
  }
  // "10. Oktober 2026" (Buunto format LL, de) -> fake-UTC midnight
  function parseLL(s) {
    var m = String(s || '').match(/(\d{1,2})\.\s*(\S+)\s+(\d{4})/), k = m ? ML.indexOf(m[2]) : -1;
    return k < 0 ? 0 : Date.UTC(+m[3], k, +m[1]);
  }
  // Buunto adds the Saturday surcharge itself when it sees /cart/add; make sure it did.
  function ensureSurcharge(ms, method) {
    var fee = surchargeFor(ms, method);
    if (!fee) return;
    var tries = 0;
    var check = function () {
      cartJSON().then(function (c) {
        var has = (c.items || []).some(function (it) { return it.variant_id === fee.variant; });
        if (has) { if (tries) refreshCart(); return; }
        if (++tries < 3) { setTimeout(check, 700); return; }
        postAdd([{ id: fee.variant, quantity: 1 }]).then(function () { refreshCart(); });
      }).catch(function () {});
    };
    setTimeout(check, 700);
  }
  function qaUI() {
    var sh = sheetEl('qa');
    if (!sh) return;
    $$('[data-bk-qa-method]', sh).forEach(function (b) {
      var on = b.getAttribute('data-bk-qa-method') === qa.method;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    $$('[data-bk-qa-method]', sh).forEach(function (b) { b.disabled = !!qa.lock; });
    var note = $('[data-bk-qa-lock]', sh);
    if (note) {
      note.hidden = !qa.lock;
      if (qa.lock) note.textContent = 'Dein Warenkorb hat schon ein Datum (' + (qa.sel ? fmt(qa.sel) : (qa.lock.Lieferdatum || qa.lock.Abholdatum)) + '). Pro Bestellung geht nur eins, dein Ballon kommt also mit.';
    }
    var go = $('[data-bk-qa-go]', sh);
    if (go) go.disabled = !qa.sel && !qa.lock;
  }
  function qaOpen(btn, lock) {
    var sh = sheetEl('qa');
    if (!sh) { addToCart(btn, lock || {}); return; }
    var w = lock ? { ms: parseLL(lock.Lieferdatum || lock.Abholdatum), m: lock.Abholdatum ? 'pickup' : 'delivery' } : loadWish();
    qa.btn = btn;
    qa.lock = lock || null;
    qa.method = w ? w.m : 'delivery';
    qa.sel = (w && w.ms) || (lock ? 0 : firstBookable(qa.method));
    qa.month = monthOff(qa.sel);
    var tt = $('[data-bk-qa-title]', sh);
    if (tt) tt.textContent = btn.getAttribute('data-title') || '';
    openSheet('qa');
    renderCals();
    qaUI();
  }
  function qaMethod(m) {
    if (qa.lock) return;
    qa.method = m === 'pickup' ? 'pickup' : 'delivery';
    if (!qa.sel || cutoffFor(qa.sel, qa.method) <= zurich(Date.now()).now) { qa.sel = firstBookable(qa.method); qa.month = monthOff(qa.sel); }
    renderCals();
    qaUI();
  }
  function qaPick(ms) {
    if (qa.lock) return;
    qa.sel = ms;
    renderCals(ms);
    qaUI();
    var r = $('[data-bk-sheet="qa"] .cal-res');
    if (r && r.scrollIntoView) r.scrollIntoView({ block: 'nearest', behavior: reduced() ? 'auto' : 'smooth' });
  }
  function qaGo() {
    var btn = qa.btn, ms = qa.sel, m = qa.method;
    if (btn && qa.lock) { var lk = qa.lock; closeSheet(); addToCart(btn, lk, function () { if (ms) ensureSurcharge(ms, m); }); return; }
    if (!btn || !ms || cutoffFor(ms, m) <= zurich(Date.now()).now) { qaUI(); return; }
    saveWish(ms, m);
    if (m === 'delivery') { cal.sel = ms; cal.month = monthOff(ms); }
    closeSheet();
    renderCals();
    addToCart(btn, buuntoProps(ms, m), function () { ensureSurcharge(ms, m); });
  }

  // Delegated events (attached once; survive theme-editor section reloads)
  function onClick(e) {
    if (suppress) { var rl = closest(e, RAIL); if (rl) { e.preventDefault(); e.stopPropagation(); suppress = false; return; } }
    var t = e.target;
    if (!t || !t.closest) return;
    var el;
    if ((el = t.closest('button[data-bk-add]'))) { e.preventDefault(); e.stopPropagation(); addToCart(el); return; }
    if ((el = t.closest('[data-bk-rail-prev]'))) { railBy(el, -1); return; }
    if ((el = t.closest('[data-bk-rail-next]'))) { railBy(el, 1); return; }
    if ((el = t.closest('[data-bk-hero-prev]'))) { heroGo(el, -1); return; }
    if ((el = t.closest('[data-bk-hero-next]'))) { heroGo(el, 1); return; }
    if ((el = t.closest('[data-bk-dot]'))) { heroGo(el, 0, +el.getAttribute('data-bk-dot')); return; }
    if ((el = t.closest('[data-bk-tab]'))) { pickTab(el); return; }
    if ((el = t.closest('[data-bk-cal-open]'))) {
      if (isMobile()) { if (openKind === 'cal') closeSheet(); else openSheet('cal'); }
      else setPop(!popOpen());
      return;
    }
    if ((el = t.closest('[data-bk-open]'))) {
      var k = el.getAttribute('data-bk-open');
      if (k === 'cal' && !isMobile()) { setPop(!popOpen()); return; }
      if (openKind === k) closeSheet(); else openSheet(k);
      return;
    }
    if (t.closest('[data-bk-sheet-close]') || t.closest('[data-bk-scrim]')) { closeSheet(); return; }
    if ((el = t.closest('[data-bk-menu-go]'))) { menuShow(el.getAttribute('data-bk-menu-go'), 1); return; }
    if (t.closest('[data-bk-menu-back]')) { menuShow('root', -1); return; }
    if (t.closest('[data-bk-cal-close]')) { closePop(); return; }
    if (t.closest('[data-bk-cal-prev]')) { var sp = stateOf(t); sp.month = Math.max(0, sp.month - 1); renderCals(); return; }
    if (t.closest('[data-bk-cal-next]')) { var sn = stateOf(t); sn.month = Math.min(2, sn.month + 1); renderCals(); return; }
    if ((el = t.closest('[data-bk-cal-pick]'))) { if (stateOf(el) === qa) qaPick(+el.getAttribute('data-bk-cal-pick')); else calPick(+el.getAttribute('data-bk-cal-pick')); return; }
    if ((el = t.closest('[data-bk-qa-method]'))) { qaMethod(el.getAttribute('data-bk-qa-method')); return; }
    if (t.closest('[data-bk-qa-go]')) { qaGo(); return; }
    if ((el = t.closest('button[data-bk-clamp-toggle]'))) {
      var w = el.closest('[data-bk-clamp]');
      if (!w) return;
      var on = !w.classList.contains('is-open');
      w.classList.toggle('is-open', on);
      el.setAttribute('aria-expanded', on ? 'true' : 'false');
      el.textContent = on ? (el.getAttribute('data-less') || 'Weniger') : (el.getAttribute('data-more') || 'Weiterlesen');
    }
  }
  function onPointerDown(e) {
    if (popOpen() && !closest(e, '.bk-cal-anchor')) closePop();
    // finger on a gliding rail/hero: hand control back to native scroll + snap
    var rr = closest(e, RAIL);
    if (rr && rr.__sp && e.pointerType !== 'mouse') { stopSpring(rr); rr.style.scrollSnapType = ''; }
    if (closest(e, '[data-bk-sheet-grab]')) { sheetDown(e); return; }
    railDown(e);
  }
  function onPointerMove(e) { railMove(e); sheetMove(e); }
  function onPointerUp(e) { railUp(e); sheetUp(e); }
  function onKey(e) {
    if (e.key !== 'Escape') return;
    if (openKind) closeSheet();
    else if (popOpen()) { closePop(); }
  }
  function onWheel(e) {
    var r = closest(e, RAIL);
    if (r && r.__sp) { stopSpring(r); r.style.scrollSnapType = ''; }
  }
  function onHeroScroll(e) {
    var h = e.target;
    if (h && h.matches && h.matches('[data-bk-hero]')) heroSync(h);
  }
  function onResize() {
    $$('[data-bk-tabs]').forEach(positionSeg);
    if (openKind && !isMobile()) sheetClosed(false); // grew past the breakpoint: release scroll lock
  }

  // Boot
  function initSection(root) {
    root = root || document;
    var segs = $$('[data-bk-tabs]', root);
    if (root.matches && root.matches('[data-bk-tabs]')) segs.push(root);
    segs.forEach(positionSeg);
    $$('[data-bk-hero]', root).forEach(heroSync);
    if (root === document || $('[data-bk-cal],[data-bk-cutoff]', root)) { tickCutoff(); renderCals(); }
  }
  function unloadSection(root) {
    $$(RAIL, root).forEach(function (r) {
      stopSpring(r); if (r.__rbk) stopSpring(r.__rbk);
      r.style.transform = ''; r.style.scrollSnapType = '';
    });
    $$('.bk-bob', root).forEach(stopSpring);
    if (drag && root.contains(drag.r)) drag = null;
  }

  function boot() {
    var w = loadWish();
    if (w && w.m === 'delivery') { cal.sel = w.ms; cal.month = monthOff(w.ms); }
    initSection(document);
    var shop = (window.Shopify && window.Shopify.shop) || 'ballonking.myshopify.com';
    fetch('https://cdn.buunto.com/datepicker_settings/' + shop + '.json').then(function (r) { return r.json(); })
      .then(function (j) { applyBuunto(j && (j.widgetSettings || j)); renderCals(); }).catch(function () {});
    document.addEventListener('click', onClick, true);
    document.addEventListener('pointerdown', onPointerDown);
    document.addEventListener('pointermove', onPointerMove);
    document.addEventListener('pointerup', onPointerUp);
    document.addEventListener('pointercancel', onPointerUp);
    document.addEventListener('pointerover', cardEnter);
    document.addEventListener('keydown', onKey);
    document.addEventListener('dragstart', function (e) { if (closest(e, RAIL)) e.preventDefault(); });
    document.addEventListener('wheel', onWheel, { passive: true });
    document.addEventListener('scroll', onHeroScroll, { passive: true, capture: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    setInterval(tickCutoff, 15000);
    requestAnimationFrame(function () { $$('[data-bk-tabs]').forEach(positionSeg); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { $$('[data-bk-tabs]').forEach(positionSeg); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) { initSection(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { unloadSection(e.target); });
})();
